import type { Toast as ToastNS } from 'radix-ui';

import {
  CloseIcon,
  CustomToast,
  Toast,
  ToastClose,
  ToastDescription,
  ToastTitle,
  ToastViewport,
} from './styles';

/*
 * 'defaultValue' and 'value' are omitted, because type 'readonly array' cannot
 * be assigned to the mutable type 'array'. It happens when trying use Immer.
 */
export interface IBaseToastProps
  extends Omit<ToastNS.ToastProps, 'defaultValue' | 'value'> {
  dataCy?: string;
  description?: string;
  styleType?: 'error' | 'info' | 'success' | 'warning';
  title?: string;
}

export const BaseToast = ({
  description,
  styleType = 'info',
  dataCy = `${styleType}-toast`,
  title,
  ...props
}: IBaseToastProps): JSX.Element => {
  return (
    <Toast {...props} data-cy={dataCy} asChild>
      <CustomToast styleType={styleType}>
        <ToastTitle data-cy={`${dataCy}-title`}>{title}</ToastTitle>
        <ToastDescription data-cy={`${dataCy}-description`}>
          {description}
        </ToastDescription>
        <ToastClose data-cy={`${dataCy}-close`}>
          <CloseIcon />
        </ToastClose>
      </CustomToast>
    </Toast>
  );
};
export interface IBaseToastViewportProps extends ToastNS.ToastViewportProps {
  dataCy?: string;
}

export const BaseToastViewport = ({
  dataCy = 'toast-viewport',
  ...props
}: IBaseToastViewportProps): JSX.Element => {
  return <ToastViewport {...props} data-cy={dataCy} />;
};
